import { render, staticRenderFns } from "./PrivacyStep.vue?vue&type=template&id=672bb534&"
import script from "./PrivacyStep.vue?vue&type=script&lang=ts&"
export * from "./PrivacyStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672bb534')) {
      api.createRecord('672bb534', component.options)
    } else {
      api.reload('672bb534', component.options)
    }
    module.hot.accept("./PrivacyStep.vue?vue&type=template&id=672bb534&", function () {
      api.rerender('672bb534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LobbySteps/PrivacyStep.vue"
export default component.exports